import { Buffer } from 'buffer';
window.Buffer = Buffer;

import ReactDOM from 'react-dom';
import App from './app';
import { registerSW } from 'virtual:pwa-register';

ReactDOM.render(<App />, document.getElementById('root'));

// Register PWA service worker for all environments (including React Native WebView).
// The service worker precaches hashed assets so that after a deployment, lazy-loaded
// chunks are served from the local cache instead of hitting the server (which would
// return index.html with text/html MIME type for deleted chunk filenames).
if ('serviceWorker' in navigator) {
  const updateServiceWorker = registerSW({
    immediate: true,
    onRegistered: (registration) => {
      if (registration) {
        window.__updateServiceWorker = async (reloadPage?: boolean) => {
          await registration.update();
          if (reloadPage) location.reload();
        };
        // Check for SW updates every 15 min so long-lived sessions
        // pick up new precache manifests before stale chunks cause errors.
        setInterval(() => registration.update(), 15 * 60 * 1000);
      }
    },
    onRegisterError: (error) => {
      console.error('SW registration failed', error);
    },
  });
  // expose a manual trigger just in case
  if (!window.__updateServiceWorker) {
    window.__updateServiceWorker = updateServiceWorker;
  }
}
